import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject, switchMap } from 'rxjs';
import { ManagedUsersListRowInterface } from '../core/models/managed-user.model';
import { UserPermissionOptionsInterface } from '../core/models/user-permissions.model';
import { PermissionsService } from '../core/services/permissions/permissions.service';
import { NavigationSearchInputComponent } from '../core/tree/search/navigation-search-input.component';
import { SearchableListParentBaseComponent } from '../inquiries/searchable-list-parent-base.component';
import { SharedModule } from '../shared/shared.module';
import { ManagedUsersListComponent } from './list/list.component';
import { AddManagedUserModalComponent } from './modals/add-managed-user-modal/add-managed-user-modal.component';
import { ManagedUsersSearchService } from './services/managed-users-search.service';
import { ManagedUsersService } from './services/managed-users.service';

@Component({
  selector: 'app-managed-users-parent',
  imports: [SharedModule, ManagedUsersListComponent, NavigationSearchInputComponent],
  templateUrl: './managed-users-parent.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [ManagedUsersSearchService],
})
export class ManagedUsersParentComponent extends SearchableListParentBaseComponent<ManagedUsersListRowInterface> implements OnInit {
  refresh$ = new Subject<void>();
  permissionOptions: UserPermissionOptionsInterface;

  protected entitySearch = inject(ManagedUsersSearchService);
  private modalService = inject(NgbModal);
  private managedUsersService = inject(ManagedUsersService);
  private permissionsService = inject(PermissionsService);

  ngOnInit(): void {
    super.ngOnInit();

    this.subscription.add(
      this.permissionsService
        .getUserPermissionsAsObservable()
        .pipe(switchMap(() => this.managedUsersService.getPermissionOptions()))
        .subscribe((options) => {
          this.permissionOptions = options;
        }),
    );
  }

  onAddUser(): void {
    const modalRef = this.modalService.open(AddManagedUserModalComponent, {
      size: 'lg',
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });

    const instance = modalRef.componentInstance as AddManagedUserModalComponent;

    instance.permissionOptions = this.permissionOptions;

    instance.addedUser.subscribe(() => {
      this.refresh$.next();
    });
  }
}
